import { connect } from 'react-redux'
import { updateStudent,getStudentData } from '../../Resume/actions'
import { getEventDetailsById, getEventsList, registerEvent } from '../actions'
import Events from '../index'

const mapStateToProps = state => ({})
const mapDispatchToProps = {
  getEventsList,
  getEventDetailsById,
  registerEvent,
  updateStudent,
  getStudentData
}

export default connect(mapStateToProps, mapDispatchToProps)(Events)
